import React, { useMemo, useCallback } from "react";
import Select from "react-select";

import useProjectOrganisationContext from "@/pages/takeoff/context/project-organisation/use-project-organisation-context.ts";
import useProjectFilePlanContext from "../context/use-project-file-plan-context.ts";

import FileType from "@/models/enums/file-type.ts";

import Card from "@/components/card";

type FileSelectorIem = { fileId: string, fileName: string, fileType: FileType };

const CopyMeasuresCard: React.FC = () => {
    const { getAllPlanFilesData } = useProjectOrganisationContext();
    const { fileLeft, fileRight, setFileIdRight, dispatchLeft: dispatch } = useProjectFilePlanContext();

    const itemsSource = useMemo(() => {
        const files2d: FileSelectorIem[] = getAllPlanFilesData()
            .filter(f => f.fileId !== fileLeft?.id)
            .map(f => ({
                fileId: f.fileId,
                fileName: f.fileName,
                fileType: FileType.File2D
            }));

        return files2d.sort((a, b) => {
            if (a.fileName.toLowerCase().endsWith(".pdf")) return -1;
            if (b.fileName.toLowerCase().endsWith(".pdf")) return 1;

            return a.fileName.localeCompare(b.fileName, "fr", { sensitivity: "base" });
        })
    }, [fileLeft?.id, getAllPlanFilesData]);

    const selectedFile = useMemo(() => {
        if (!fileRight) return null;

        return itemsSource.find(f => f.fileId === fileRight.id) ?? null;
    }, [itemsSource, fileRight]);

    const handleSelectionFileChanged = useCallback((selectedItem: FileSelectorIem | null) => {
        if (!selectedItem) return;

        if (selectedItem.fileId === fileRight?.id)
            return;

        setFileIdRight(selectedItem.fileId);

        dispatch({
            type: 'set-dirty-flag',
            isDirty: true
        })
    }, [fileRight?.id, setFileIdRight, dispatch]);
    
    return (
        <Card additionalClasses='pointer-events-auto select-none w-96'
              additionalContentClasses='flex flex-col gap-y-2 px-4 py-2'>
            <div className='text-sm'>Choisissez le plan Source</div>
            <Select className='w-full'
                    placeholder='Sélectionnez un plan'
                    options={itemsSource} value={selectedFile}
                    getOptionValue={f => f.fileId}
                    getOptionLabel={(selectedItem: FileSelectorIem) => selectedItem.fileName}
                    onChange={handleSelectionFileChanged}
                    classNames={{
                        control: () => "!min-h-0 !rounded-md !border-gray-200",
                        menu: () => "text-sm",
                        menuList: () => "text-sm",
                        singleValue: () => "text-sm",
                        placeholder: () => "text-sm",
                        indicatorsContainer: () => "-my-1",
                    }}
            />
        </Card>
    )
}

export default CopyMeasuresCard;